var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "flex v-center"
  }, [_c('router-link', {
    staticClass: "flex v-center",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "m-right-10",
    attrs: {
      "src": require("../../../assets/img/brasao.png")
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "thin"
  }, [_vm._v("\n\t\t\tCOMUNIQUE-SE ON-LINE\n\t\t\t"), _c('span', {
    staticStyle: {
      "color": "tomato"
    }
  }, [_vm._v("CONSULTA DE PROCESSOS")])])]), _vm._v(" "), (_vm.$store.config.ENV) ? _c('span', {
    staticClass: "env-label"
  }, [_vm._v(_vm._s(_vm.$store.config.ENV))]) : _vm._e(), _vm._v(" "), (_vm.$store.usuario && Object.keys(_vm.$store.usuario).length > 0) ? [_c('span', {
    staticClass: "flex v-center m-left-auto"
  }, [_c('span', {
    staticClass: "thin m-right-10",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$store.usuario.nome.toUpperCase()))]), _vm._v(" "), _c('a', {
    staticClass: "logout-button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [(_vm.loading) ? [_c('span', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Processando\n\t\t\t\t")] : [_vm._v("\n\t\t\t\t\tSAIR\n\t\t\t\t")]], 2)])] : _vm._e()], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7e4af99a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e4af99a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./application/views/commons/header.vue
// module id = 252
// module chunks = 3